import type { ValidationCheck } from '../../types/checks.js';
import { backgroundQualityCheck } from '../backgroundQualityCheck.js';
import { highlightCheck } from '../highlightCheck.js';
import { lightingBalanceCheck } from '../lightingBalanceCheck.js';
import { shadowBackgroundCheck } from '../shadowBackgroundCheck.js';
import { shadowFaceCheck } from '../shadowFaceCheck.js';

/**
 * Light and image-quality checks: exposure, shadows, highlights, balance,
 * sharpness, noise, compression.
 *
 * Shadow on the face and shadow on the background are deliberately separate
 * checks: the fixes are different, and a shadow behind the person is not a
 * problem with the face.
 */
export const LIGHT_QUALITY_CHECKS: readonly ValidationCheck[] = [
  highlightCheck,
  lightingBalanceCheck,
  shadowFaceCheck,
  shadowBackgroundCheck,
  backgroundQualityCheck,
];
